export enum PackageType {
  COOLER = 'Cooler',
  CARTON = 'Carton/Box',
  PALLET = 'Pallet',
}
